<template>
  <div id="app" class="app_content img_cover">
    <header-component />

    <main class="main">
      <div class="container_wrap main-content">
        <div class="container">
          <div class="main-content">
            <h1>Next Level of Full cycle development</h1>
            <div class="divider"></div>
            <h2>We're providing all your ideas to life.</h2>
            <button class="btn btn-primary" data-text="Let's Get Started" @click="sendMail()">
              <span class="text">Let's Get Started</span>
            </button>
          </div>
        </div>
      </div>
    </main>

    <footer-component />
  </div>
</template>

<script>

import { TimelineMax } from 'gsap';

import HeaderComponent from '@/shared/components/Header';
import FooterComponent from '@/shared/components/Footer';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  },
  methods: {
    sendMail () {
      location.href = 'mailto:info@yual.io';
    }
  },
  mounted () {
    var tl = new TimelineMax();
    tl
      .to(('.main-content h1'), 0.3, { opacity: 1, x: 0 }, '+=1')
      .to(('.divider'), 0.3, { opacity: 1, x: 0 })
      .to(('.main-content h2'), 0.3, { opacity: 1, x: 0 })
      .to(('.main-content .btn'), 0.3, { opacity: 1, scale: 1 });
  }
};
</script>

<style lang="scss">
  @import '@/assets/styles';
</style>
